import React, { Suspense, useEffect, useState } from "react";
import { renderRoutes } from "react-router-config";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { LinearProgress } from "@material-ui/core";
import Cookies from "js-cookie";
import { NavBar, TopBar, ChatBar, CitySparkHeader } from "./components";
import theme from "theme";

const useStyles = makeStyles(() => ({
  root: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  topBar: {
    zIndex: 2,
    position: "relative",
  },
  container: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  navBar: {
    zIndex: 3,
    width: 256,
    minWidth: 256,
    flex: "0 0 auto",
  },
  content: {
    overflowY: "auto",
    flex: "1 1 auto",
    paddingBottom: "60px",
  },
  navBarNotVisible: {
    display: "none",
  },
}));

const Dashboard = (props) => {
  const { route } = props;

  const classes = useStyles();
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);
  const [disableTopbarAndNavBar, setDisableTopbarAndNavBar] = useState(
    window.location.pathname.indexOf("email-link") >= 0 ? true : false
  );
  const [topBarLoaded, setTopBarLoaded] = useState(true);
  const [isNavBarTopBarVisible, setIsNavBarTopBarVisible] = useState(true);
  const handleNavBarMobileOpen = () => {
    setOpenNavBarMobile(true);
  };

  const handleNavBarMobileClose = () => {
    setOpenNavBarMobile(false);
  };
  // Declare CitySparkHeader as a global variable to avoid lint errors
  // eslint-disable-next-line no-undef
  const disableNavBarAndTopBar = () => {
    console.log("inside disableNavBarAndTopBar");

    setIsNavBarTopBarVisible((prev) => !prev);
  };

  return (
    <div className={classes.root}>
      <CitySparkHeader
        className={classes.citySparkHeader}
        disableNavBarAndTopBar={disableNavBarAndTopBar}
      />
      {/* {isNavBarTopBarVisible && (
        <TopBar
          className={classes.topBar}
          onOpenNavBarMobile={handleNavBarMobileOpen}
          onTopBarLoaded={setTopBarLoaded}
        />
      )} */}

      <div className={classes.container}>
        {topBarLoaded &&
          isNavBarTopBarVisible &&
          window.location.pathname != "/photo-campaign-error-privilages" && (
            <NavBar
              className={
                isNavBarTopBarVisible
                  ? classes.navBar
                  : classes.navBarNotVisible
              }
              onMobileClose={handleNavBarMobileClose}
              openMobile={openNavBarMobile}
              topBarLoaded={topBarLoaded}
              handleNavBarMobileOpen={handleNavBarMobileOpen}
              setTopBarLoaded={setTopBarLoaded}
            />
          )}
        {topBarLoaded && (
          <main className={classes.content}>
            <Suspense fallback={<LinearProgress />}>
              {renderRoutes(route.routes)}
            </Suspense>
          </main>
        )}
      </div>
      <ChatBar />
    </div>
  );
};

Dashboard.propTypes = {
  route: PropTypes.object,
};

export default Dashboard;
